import Joi from '@hapi/joi'

export const RevenueSharedPaymentCalculationSchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Group required`,
        
    }),
    estate: Joi.number().invalid(0).required().label("Estate").messages({
        "any.invalid": `Estate required`,
    }),
    registrationNumber:  Joi.string().allow("", null).alphanum().max(10).required().label("Registration Number").messages({
        "string.pattern.base": `Please enter valid Registration Number`,
        "string.max": `Please enter {#limit} characters.`
    }),
    weedCondition:  Joi.string().allow("", null).alphanum().max(10).required().label(" Weed Condition").messages({
        "string.pattern.base": `Please enter valid Weed Condition`,
        "string.max": `Please enter {#limit} characters.`
    }),
    date: Joi.string().invalid("").label("Month").messages({
        "any.invalid": `Date required`,
    })
}